import {ISolution, getTimezoneOffset, UserActivityCategoryEnum} from '@mobi-components/global-solution';

export function adjustToDestinationTimezone(localDateValueMils: number, destTimeZone = '') {
  const startTimezoneOffset = getTimezonOffsetMins(destTimeZone);
  return localDateValueMils + startTimezoneOffset * 60 * 1000;
}

export function getTimezonOffsetMins(timezone = '') {
  const localTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  timezone = timezone || localTimeZone;
  const myTzOffsetMins = new Date().getTimezoneOffset();
  const startTimezoneOffset = Math.round(getTimezoneOffset(new Date(), timezone)) - myTzOffsetMins;
  return startTimezoneOffset;
}

export function fixDate(date: number, timezone = ''): number {
  let startTimezoneOffset = 0;
  try {
    startTimezoneOffset = getTimezonOffsetMins(timezone);
  } catch {
    startTimezoneOffset = 0;
  }
  return date - startTimezoneOffset * 60;
}

export function fixSolutionDates(solution?: ISolution | null): ISolution | null {
  const localTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  if (!solution) {
    return null;
  }
  const updatedActivities = solution.activities.map((x) => {
    const startLocation = solution.locations.find((y) => y.id === x.start_location);
    const endLocation = solution.locations.find((y) => y.id === x.end_location);
    const updatedActivity = {
      ...x,
      scheduled_start_time: fixDate(x.scheduled_start_time, startLocation?.time_zone || localTimeZone),
      scheduled_end_time: fixDate(x.scheduled_end_time, endLocation?.time_zone || localTimeZone),
      original_start_time: x.scheduled_start_time,
      original_end_time: x.scheduled_end_time,
    };
    return updatedActivity;
  });

  const firstFlightIndex = updatedActivities.findIndex((x) => x.category === UserActivityCategoryEnum.FLIGHT);
  const shortList = updatedActivities.slice(firstFlightIndex + 1);

  const lastFlightIndexBack = shortList.reverse().findIndex((x) => x.category === UserActivityCategoryEnum.FLIGHT);
  const lastFlightIndex = updatedActivities.length - lastFlightIndexBack - 1;

  if (firstFlightIndex >= 0 && lastFlightIndex >= 0 && updatedActivities.length >= lastFlightIndex) {
    updatedActivities.splice(0, firstFlightIndex);
    updatedActivities.splice(
      lastFlightIndex - firstFlightIndex + 1,
      updatedActivities.length - lastFlightIndex + firstFlightIndex,
    );
  }

  return {
    ...solution,
    activities: updatedActivities,
  };
}
